import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import i18n from "../util/i18n.ts";
import { MobileTooltip } from "./MobileTooltip.tsx";

export type FastForward = {
	id?: string;
	onClick: () => void;
	label: string;
};

export const PlayPauseNext = ({
	className,
	disabled,
	fastForwardAlignRight,
	fastForwards,
	onPlay,
	onPause,
	onNext,
	paused,
	titlePlay,
	titlePause,
	titleNext,
}: {
	className?: string;
	disabled?: boolean;
	fastForwardAlignRight?: boolean;
	fastForwards?: FastForward[];
	onPlay: () => void;
	onPause: () => void;
	onNext: () => void;
	paused: boolean;
	titlePlay?: string;
	titlePause?: string;
	titleNext?: string;
}) => {
	const titlePlayFinal =
		titlePlay ?? i18n.t("playPauseNext.play", { ns: "ui", defaultValue: "Play" });
	const titlePauseFinal =
		titlePause ??
		i18n.t("playPauseNext.pause", { ns: "ui", defaultValue: "Pause" });
	const titleNextFinal =
		titleNext ?? i18n.t("common.next", { ns: "ui", defaultValue: "Next" });
	const fastForwardTitle = i18n.t("playPauseNext.fastForward", {
		ns: "ui",
		defaultValue: "Fast Forward",
	});

	return (
		<div
			className={clsx("btn-group", className)}
			data-play-pause-next=""
			data-play-pause-next-disabled={disabled ? "true" : "false"}
			data-play-pause-next-state={paused ? "paused" : "running"}
		>
			{paused ? (
				<MobileTooltip title={titlePlayFinal}>
					<button
						aria-label={titlePlayFinal}
						className="btn btn-light-bordered"
						data-play-pause-next-action="play"
						disabled={disabled}
						onClick={onPlay}
					>
						<span className="glyphicon glyphicon-play" />
					</button>
				</MobileTooltip>
			) : (
				<MobileTooltip title={titlePauseFinal}>
					<button
						aria-label={titlePauseFinal}
						className="btn btn-light-bordered"
						data-play-pause-next-action="pause"
						disabled={disabled}
						onClick={onPause}
					>
						<span className="glyphicon glyphicon-pause" />
					</button>
				</MobileTooltip>
			)}
			<MobileTooltip title={titleNextFinal}>
				<button
					aria-label={titleNextFinal}
					className="btn btn-light-bordered"
					data-play-pause-next-action="next"
					disabled={disabled || !paused}
					onClick={onNext}
				>
					<span className="glyphicon glyphicon-step-forward" />
				</button>
			</MobileTooltip>
			{fastForwards ? (
				<Dropdown align={fastForwardAlignRight ? "end" : undefined}>
					<Dropdown.Toggle
						id="fast-forward"
						data-play-pause-next-fast-forward=""
						className="btn-light-bordered fast-forward"
						disabled={disabled || !paused || fastForwards.length === 0}
						variant={"no-class" as any}
						aria-label={fastForwardTitle}
					>
						<span className="glyphicon glyphicon-fast-forward" />
					</Dropdown.Toggle>
					<Dropdown.Menu data-play-pause-next-fast-forward-menu="">
						{fastForwards.map((item, i) => (
							<Dropdown.Item
								data-live-game-fast-forward-id={item.id}
								key={item.id ?? i}
								onClick={item.onClick}
							>
								{item.label}
							</Dropdown.Item>
						))}
					</Dropdown.Menu>
				</Dropdown>
			) : null}
		</div>
	);
};
